"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ListItemSecondaryAction_1 = __importDefault(require("@mui/material/ListItemSecondaryAction"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    chips: {
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },
    chip: {
        backgroundColor: '#f37f30',
    },
    registerButton: {
        backgroundColor: '#f37f30',
        color: 'white',
        marginBottom: '20px',
    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
}); });
function QuestionLI(prop) {
    var _a;
    var children = prop.children, fetchQuestion = prop.fetchQuestion, setQuestionToDelete = prop.setQuestionToDelete, setSelectedQuestion = prop.setSelectedQuestion, setDeleteOpen = prop.setDeleteOpen, setQuestionOpen = prop.setQuestionOpen, setValue = prop.setValue, setAmenityOpen = prop.setAmenityOpen, setAmenityChecks = prop.setAmenityChecks, amenities = prop.amenities;
    var classes = useStyles();
    var question = children;
    var primary = question.question;
    var numberOfAmenities = (_a = question.amenities) === null || _a === void 0 ? void 0 : _a.length;
    var remainingAmenities = numberOfAmenities - 3;
    var _b = (0, react_1.useState)([]), expandedAmenities = _b[0], setExpandedAmenities = _b[1];
    var expandQuestion = function (id) {
        var existing = expandedAmenities;
        existing[id] = true;
        setExpandedAmenities(existing);
        fetchQuestion();
    };
    function deleteQuestion(theQuestion) {
        setQuestionToDelete(theQuestion.id);
        setSelectedQuestion(theQuestion);
        setDeleteOpen(true);
    }
    function editQuestion(theQuestion) {
        setSelectedQuestion(theQuestion);
        setValue(theQuestion.question);
        setQuestionOpen(true);
    }
    var openAmenity = function (theQuestion) {
        setSelectedQuestion(theQuestion);
        var checkedValues = [];
        Object.keys(theQuestion.amenities).forEach(function (a) {
            var index = theQuestion.amenities[Number(a)].id;
            checkedValues[index] = true;
        });
        Object.keys(amenities).forEach(function (a) {
            var index = amenities[Number(a)].id;
            if (!checkedValues[index]) {
                checkedValues[index] = false;
            }
        });
        setAmenityChecks(checkedValues);
        setAmenityOpen(true);
    };
    var secondary = (react_1.default.createElement("div", { className: classes.chips },
        !(numberOfAmenities > 0) && (react_1.default.createElement(react_1.default.Fragment, null, "No associated amenities.")),
        question.amenities && question.amenities.map(function (amenity, index) { return ((index < 3 || expandedAmenities[question.id]) && (react_1.default.createElement(Chip_1.default, { label: amenity.name, classes: { colorPrimary: classes.chip }, color: "primary", size: "small" }))); }),
        (remainingAmenities > 0 && !expandedAmenities[question.id]) && (react_1.default.createElement(Chip_1.default, { label: "".concat(remainingAmenities, " more."), classes: { colorPrimary: classes.chip }, onClick: function () { return expandQuestion(question.id); }, color: "primary", size: "small" })),
        react_1.default.createElement(IconButton_1.default, { "aria-label": "delete", size: "small" },
            react_1.default.createElement(Add_1.default, { fontSize: "inherit", onClick: function () { return openAmenity(question); } }))));
    return (react_1.default.createElement(ListItem_1.default, null,
        react_1.default.createElement(ListItemText_1.default, { primary: primary, secondary: secondary }),
        react_1.default.createElement(ListItemSecondaryAction_1.default, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "edit", onClick: function () { editQuestion(question); }, size: "large" },
                    react_1.default.createElement(Edit_1.default, null)),
                react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "delete", onClick: function () { deleteQuestion(question); }, size: "large" },
                    react_1.default.createElement(Delete_1.default, null))))));
}
exports.default = QuestionLI;
